import React, { useEffect, useState } from 'react'
import { connect } from "react-redux";
import emailjs from "@emailjs/browser";
import "./CSS/Forgot_PWD.css"
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import loading_ from "../Assets2/loading.gif";

const Forgot_PWD = (props) => {

  const history = useHistory()


  const [temp_si, Set_temp_si] = useState("")

  const [user_email, Set_user_email] = useState("")

  const [time, Set_time] = useState(60);

  const [re_send_active, Set_re_send_active] = useState(false)

  const [intervalId, setIntervalId] = useState(null);

  const [match_true, Set_match_true] = useState(false)




  useEffect(() => {
    Set_user_email(props.temp_email)
    console.log(props.temp_email);
    setTimeout(() => {
      Send_email()

    }, 800)

  }, [])

  useEffect(() => {
    if (time < 1) {
      Set_time(0)
      Set_re_send_active(true)
      clearInterval(intervalId)
    }
  }, [time])

  const chech_match = (sif) => { // onChangeile input alannda kontrol et
    if (sif === temp_si) {
      Set_match_true(true)
    }
  }

  const isValidEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
}

  const Send_email = async () => {

   

    console.log(props.temp_email);

    var string_ = "";
    var i = 0;
    while (i < 6) {
      var num_ = Math.floor(Math.random() * 10);
      string_ += num_
      i++;
    }
    Set_temp_si(string_)
    const id = setInterval(() => {
      Set_time((prevTime) => prevTime - 1);
    }, 1000);

    // intervalId'yi sakla
    setIntervalId(id);
    console.log(id);
    const serviceId = 'service_8tmkb36';
    const templateId = 'template_e9fzq9i';
    const userId = '4-r7tNEIt3QqBqHPa';

    // Verileri oluştur
    const templateParams = {
      name: "RMMS",
      message: string_,
      to_email: props.temp_email
    };

    // E-posta gönder
    emailjs.send(serviceId, templateId, templateParams, userId)
      .then((response) => {
        console.log('E-posta gönderildi:', response);
      }, (error) => {
        console.error('E-posta gönderirken hata oluştu:', error);
      });
  };

  const change_the_pwd = async (e) => {
    e.preventDefault()
    console.log(props.temp_email);
    let first_inp = document.querySelector("#new_pwd");
    let second_inp = document.querySelector("#confirm_pwd");

    if (first_inp.value !== "" && second_inp.value !== "") {
      if (first_inp.value === second_inp.value) {
        try {
          const request = await fetch("https://app-rmmsapi.azurewebsites.net/api/person/ChangePwd", {
            method: "POST",
            headers: {
              "Content-type": "application/json",
              "accept": "application/json"
            },
            body: JSON.stringify({
              "email": props.temp_email,
              "password": first_inp.value
            })
          })

          if (request.status === 200) document.querySelector(".alert_redirect_login").classList.toggle("alert_redirect_login_active"); setTimeout(() => { history.push("/") }, 2500);
          const response = await request.json()
          console.log(response);
        }
        catch (err) {
          console.log(err);
        }


      }

    }
  }


  return (
    <main className='forgot_pwd_main'>

      <div className='change_pwd_area2'>

        <div className="change_pwd_area">
          <form >
            <label htmlFor="password">New Password</label>
            <input type="password" name="first_pwd" id="new_pwd" />
            <div></div>
            <br />
            <label htmlFor="password">Confirm Password</label>
            <input type="password" name="second_pwd" id="confirm_pwd" />
            <div></div>
            <br />
            <button onClick={change_the_pwd} className='save_new_pwd_btn'>Save</button>

          </form>
        </div>
        <div className="alert_redirect_login">The password has changed succesfully. You are about the redirect to login page.</div>


      </div>

      <div className='container_forgot_pwd'>
        <div className='group_f_pwd'>
          <h6>Reset code has sent to <span style={{ textDecoration: "underline" }}>{user_email}</span></h6>
          <input onChange={(e) => {
            chech_match(e.target.value)
          }} type="text" className='enter_code' placeholder='enter code' />
          <div className="re_send">
            <button onClick={() => {
              document.querySelector(".alert_re_send").classList.toggle("alert_re_send_active")
              Set_time(60)

              Send_email()
              Set_re_send_active(false)
              setTimeout(() => {
                document.querySelector(".alert_re_send").classList.toggle("alert_re_send_active")
              }, 4000)
            }} disabled={re_send_active ? false : true} className={re_send_active ? 're_send_btn_active' : "re_send_btn"}>Re-Send {time > 1 ? "(" + time + ")" : ""}</button>
          </div>

          <button onClick={() => {
            if (match_true === true) {
              setTimeout(() => {
                document.querySelector(".container_forgot_pwd").classList.toggle("container_forgot_pwd_inactive")
                document.querySelector(".change_pwd_area").classList.toggle("change_pwd_area_active")
                document.querySelector(".change_pwd_area2").classList.toggle("change_pwd_area2_active")
              }, 1500)

              document.querySelector(".xc-loading_fpwd").classList.toggle("xc-loading_fpwd_active")
            }
          }} className='reset_btn'>Reset</button>
        </div>
        <div className="loading xc-loading_fpwd"> <img style={{ position: "relative", top: "50px", left: "40%", width: "100px" }} src={loading_} alt="" /></div>
        <div className="alert_re_send">The code has sent</div>
      </div>

    </main>
  )
}
const MapStateToProps = (state) => {
  return {
    temp_email: state.project_reducer.temp_email,
    auth_reducer: state.auth_reducer.user_id,

  }
}
export default connect(MapStateToProps)(Forgot_PWD)